import axios from 'axios'
// import qs from 'qs'
const baseUrl = (process.env.NODE_ENV=='production')?'http://apiv2.zhongzhanbao.com':'http://localhost:5000'
axios.defaults.timeout = 15000;
axios.defaults.withCredentials=true
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.baseURL = baseUrl

// axios.interceptors.request.use((config) => {
//     // 在发送请求之前做某件事
//     if(config.method  === 'post'){
//         config.data = qs.stringify(config.data);
//     }
//     return config;
// },(error) =>{
//     console.log('错误的传参')
//     return Promise.reject(error);
// });

//返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) =>{
    //对响应数据做些事
    if(!res.data.success){
        return Promise.resolve(res);
    }
    return res;
}, (error) => {
    console.log('网络异常')
    return Promise.reject(error);
});

export function fetchPost(url, params) {
    console.log(params)
    return new Promise((resolve, reject) => {
        axios.post(axios.defaults.baseURL+url, params)
            .then(response => {
                resolve(response);
            }, err => {
                reject(err);
            })
            .catch((error) => {
                reject(error)
            })
    })
}

////返回一个Promise(发送get请求)
export function fetchGet(url, param) {
    return new Promise((resolve, reject) => {
        axios.get(axios.defaults.baseURL+url, {params: param})
            .then(response => {
                resolve(response)
            }, err => {
                reject(err)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
export default {
    fetchPost,
    fetchGet,
}